export const BYTES_IN_KB = 1024;
export const BYTES_PER_GB = BigInt(BYTES_IN_KB * BYTES_IN_KB * BYTES_IN_KB);
export const BASE_STORAGE_LIMIT = BYTES_PER_GB * BigInt(BYTES_IN_KB);

export const STORAGE_WARNING_THRESHOLD = 80;
export const STORAGE_FULL_THRESHOLD = 100;
